import firebase from "firebase/app";
import { SpaceCategory } from "@lifeat/shared/data-models/virtual-space/SpaceCategory";
import { wasAccountCreatedBeforeDate } from "@lifeat/shared/user/UserUtil";

/**
 * Determines if user has free access to space
 * Users who created an account before the making K-Pop spaces pro are allowed free access to all K-Pop spaces.
 * (Even the ones marked as premium)
 * @param user
 * @param spaceCategory
 */
export const isLegacyUserWithFreeSpaceAccess = (user: firebase.User | null, spaceCategory: SpaceCategory): boolean => {
    const approxReleaseDate = new Date(2024, 4, 28); // around when k-pop spaces were made pro
    const isExistingUser = user?.metadata?.creationTime
        ? wasAccountCreatedBeforeDate(user.metadata.creationTime, approxReleaseDate)
        : false;
    return spaceCategory === SpaceCategory.KPOP && isExistingUser;
};
